import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getSessionId = () => {
  let sid = sessionStorage.getItem('credlocity_session');
  if (!sid) {
    sid = 'sess_' + Math.random().toString(36).substr(2, 12) + Date.now().toString(36);
    sessionStorage.setItem('credlocity_session', sid);
  }
  return sid;
};

export const trackPageView = (page, title) => {
  try {
    fetch(`${API_URL}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: page || window.location.pathname,
        title: title || document.title,
        referrer: document.referrer,
        session_id: getSessionId(),
      }),
    }).catch(() => {});
  } catch {}
};

export const trackSignup = (sourcePage, signupType, email, name) => {
  try {
    return fetch(`${API_URL}/api/analytics/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        source_page: sourcePage,
        form_id: `${sourcePage}_form`,
        page_url: window.location.pathname,
        signup_type: signupType,
        email: email || '',
        name: name || '',
        referrer: document.referrer,
        session_id: getSessionId(),
      }),
    }).catch(() => {});
  } catch {}
};

function injectGA(gaId) {
  if (window._gaInjected) return;
  window._gaInjected = true;
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script1);
  const script2 = document.createElement('script');
  script2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());`;
  document.head.appendChild(script2);
}

export default function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef('');
  const gaIdRef = useRef(null);

  useEffect(() => {
    fetch(`${API_URL}/api/site-settings`)
      .then(r => r.ok ? r.json() : null)
      .then(settings => {
        const gaId = settings?.google_analytics_id;
        if (gaId && /^G-[A-Z0-9]+$/.test(gaId)) {
          injectGA(gaId);
          gaIdRef.current = gaId;
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === lastTracked.current) return;
    if (path.startsWith('/admin')) return;
    lastTracked.current = path;
    setTimeout(() => {
      trackPageView(path, document.title);
      if (gaIdRef.current && window.gtag) {
        window.gtag('config', gaIdRef.current, { page_path: path });
      }
    }, 500);
  }, [location.pathname]);
}
